var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveredPo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M0.333252 23C0.333252 10.2975 10.6307 0 23.3333 0H37.3333C50.0358 0 60.3333 10.2975 60.3333 23V37C60.3333 49.7025 50.0358 60 37.3333 60H23.3333C10.6307 60 0.333252 49.7025 0.333252 37V23Z",
    fill: "#009688"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_183_4023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5784 43.4607C19.8899 43.4607 19.3298 42.9009 19.3298 42.2124V20.2417C19.3298 19.5535 19.8899 18.9934 20.5784 18.9934H22.6379V23.9243H35.1213V18.9934H37.1187C37.8071 18.9934 38.3672 19.5535 38.3672 20.2417V34.1099L40.8638 31.3301V20.2417C40.8638 18.1768 39.1838 16.4966 37.1187 16.4966H32.4109C31.8958 15.0435 30.5073 14 28.8796 14C27.2522 14 25.8638 15.0435 25.3486 16.4966H20.5784C18.5132 16.4966 16.8333 18.1768 16.8333 20.2417V42.2124C16.8333 44.2776 18.5132 45.9575 20.5784 45.9575H30.7339L28.1111 43.4607H20.5784ZM27.6313 18.9934V17.7451C27.6313 17.0566 28.1914 16.4966 28.8796 16.4966C29.5681 16.4966 30.1282 17.0566 30.1282 17.7451V18.9934H32.6248V21.4277H25.1348V18.9934H27.6313ZM35.8704 28.9177H26.8201V26.4209H35.8704V28.9177ZM24.3232 26.4209V28.9177H21.8267V26.4209H24.3232ZM26.8823 33.9111V31.4143H35.8704V33.9111H26.8823ZM24.3857 33.9111H21.8267V31.4143H24.3857V33.9111ZM21.8267 36.4077H24.3232V38.9043H21.8267V36.4077Z",
    fill: "#009688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3997 46L44.7886 34.4331L42.9312 32.7646L34.2595 42.4197L29.366 37.7615L27.6445 39.5698L34.3997 46Z",
    fill: "#00BFA5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_183_4023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14.8333 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveredPo);
export default __webpack_public_path__ + "static/media/delivered-po.1044bc495a158a8e807efe77289ca4dc.svg";
export { ForwardRef as ReactComponent };